<template>
    <div class="card-panel">
        <div class="card-body">
            <h4>Internet Status</h4>
            <div class="warp-internet-status" >
                <div class="pull-left">
                    <img src="@/assets/img/home/Group_24.png">
                </div>
                <div class="pull-left" style="position:relative;">
                    <img src="@/assets/img/home/Path_231.png">
                </div>
                <div class="pull-left">
                    <img src="@/assets/img/home/Group_34.png">
                </div>
                <div class="pull-left">
                    <img v-if="netStatus" src="@/assets/img/home/Path_231.png">
                    <img v-else src="@/assets/img/home/ico_home_no.png">
                </div>
                <div class="pull-left">
                    <img src="@/assets/img/home/Group_35.png">
                </div>
            </div>
            <div class="form-group text-center" v-if="wanAddr && netStatus">
                <p>IPv4 Address: <span class="text-green-highlight">{{wanAddr}}</span></p>
            </div>
            <div class="form-group text-center" v-if="wanAddrv6 && netStatus">
                <p>IPv6 Address: <span class="text-green-highlight">{{wanAddrv6}}</span></p>
            </div>
            <div class="form-group text-center" v-if="wanDns && netStatus">
                <p>DNS IPv4 Address: <span class="text-green-highlight">{{wanDns}}</span></p>
            </div>
             <div class="form-group text-center" v-if="wanDnsv6 && netStatus">
                <p>DNS IPv6 Address: <span class="text-green-highlight">{{wanDnsv6}}</span></p>
            </div>
            <div class="form-group text-center" v-if="wanUptime && netStatus">
                <p>{{isPPPoE ? 'PPPoE' : 'WAN'}} Uptime: <span class="text-green-highlight">{{wanUptime}}</span></p>
            </div>
        </div>
        <div class="card-footer border-top home-btn">
            <el-button  :loading="isLoad" @click="connect">Re-Connect</el-button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isLoad: false,
            netStatus:false,
            wanAddr:"0.0.0.0",
            wanAddrv6:"0.0.0.0",
            wanDns:"0.0.0.0",
            wanDnsv6:"0.0.0.0",
            wanUptime:"",
            isPPPoE:true,
        }
    },
    created(){
        this.connect()
    },
    methods:{
        connect(){
            this.isLoad = true
            this.wanAddr = "0.0.0.0"
            this.wanDns = "0.0.0.0"
            axios
            .post("/boafrm/fhGetInternetStatus")
            .then((response)=>{
                this.isLoad = false
                this.netStatus = response.data.netStatus
                this.wanAddr = response.data.wanAddr
                this.wanAddrv6 = response.data.wan6Addr
                this.wanDns = response.data.wanDns  
                this.wanDnsv6 = response.data.wan6Dns
                if(response.data.wanUptime && response.data.wanUptime !== '0day:0h:0m:0s')
                    this.wanUptime = response.data.wanUptime

                this.isPPPoE =  response.data.isPPPoE
            })
        }
    }
}
</script>



